import ThankYouRegisterContainer from "../../Component/ThankYouRegister/ThankYouRegisterContainer";

const ThankYouRegister = () => {
  return (
    <div className="page-body">
        <ThankYouRegisterContainer/>
    </div>
  )
}

export default ThankYouRegister;